module.exports = __webpack_public_path__ + "montserrat-lightitalic-webfont.7ea56e05fe06af0146bc.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-lightitalic-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-lightitalic-webfont.woff
// module chunks = styles